
import Main from "layouts/Main";


function NotificationPage() {

  return (
    <>
    <Main namePage="แจ้งเตือน"  >
      <div className="layout-content">
        <h1> Comming Soon ..... </h1>
      </div>
      </Main>
    </>
  );
}

export default NotificationPage;